// extracted by mini-css-extract-plugin
export var adjacentSlide = "_nw-9";
export var arrowButtonContainer = "_nw-5";
export var arrowButtonIcon = "_nw-6";
export var carouselArrowButton = "_nw-2";
export var carouselElementContainer = "_nw-1";
export var currentSlide = "_nw-8";
export var left = "_nw-3";
export var otherSlide = "_nw-a";
export var productCarouselContainer = "_nw-0";
export var right = "_nw-4";
export var sliderOverflow = "_nw-7";